import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ContactDetailsWizardActions = {
  getContactDetailsWizardSettings: async () => {
    return axiosRequest.get('/contact_details_wizard/settings').
      then(({ data }) => data).
      catch(handleError)
  },
}
